"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticsIntervalTypeEnum = void 0;
var StatisticsIntervalTypeEnum;
(function (StatisticsIntervalTypeEnum) {
    StatisticsIntervalTypeEnum["AllTime"] = "allTime";
    StatisticsIntervalTypeEnum["LastYearBeginning"] = "lastYearBeginning";
    StatisticsIntervalTypeEnum["ThisYearBeginning"] = "thisYearBeginning";
    StatisticsIntervalTypeEnum["ThisMonthBeginning"] = "thisMonthBeginning";
    StatisticsIntervalTypeEnum["LastThirtyDays"] = "lastThirtyDays";
    StatisticsIntervalTypeEnum["LastSevenDays"] = "lastSevenDays";
    StatisticsIntervalTypeEnum["LastQuarter"] = "lastQuarter";
    StatisticsIntervalTypeEnum["Today"] = "today";
})(StatisticsIntervalTypeEnum = exports.StatisticsIntervalTypeEnum || (exports.StatisticsIntervalTypeEnum = {}));
//# sourceMappingURL=statistics-interval-type-enum.js.map